import React from 'react'
import {FormControlLabel, Radio} from '@mui/material'
import {motion} from 'framer-motion'
import {titleColor} from '../../../metrics.module.scss'
import './listRoutes.scss'

const ListRoutes = ({date, routes, onClick}) => {
    const handleClick = (value) => onClick(date, value.time)
    return <motion.div
        initial={{x: 400}}
        animate={{x: 0}}
        transition={{duration: 0.3}}>
        <div className={'list-routes'}>
            {routes.map(time =>
                <FormControlLabel
                    key={time.time}
                    sx={{'& .MuiTypography-root': {fontFamily: 'Nunito'}}}
                    control={<Radio style={{color: titleColor, fontFamily: 'Nunito'}}/>}
                    label={time.time.substring(0, 5)}
                    onClick={() => handleClick(time)}/>
            )}
        </div>
    </motion.div>
}

export default ListRoutes
